/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/sneakfreaxx/"

const COMMUNITY_ICON = `${S3_PREFIX}community-icon.jpg`

const SNEAKFREAXX: CommunityData = {
  code: "sneakfreaxx",
  inviteCode: "sneakfreaxx",
  name: "SNEAKFREAXX",
  thumbnail: COMMUNITY_ICON,
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/snx-030`,
  waitlist: false,
  socials: {},
  styles: {
    // Derived from web styles per .agents/skills/onboard-community/references/wm.md#coming-soon-page.
    // Light theme: white left container, red title, blue hero bg.
    comingSoon: {
      bgColor: "#ffffff",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[140px] h-[36px] sm:w-[190px] sm:h-[48px] object-contain",
      },
      werzLogoColor: "#191818",
      title: "font-['RubikBlack'] text-[28px] leading-[120%] uppercase text-[#b6091e]",
      text: "font-['RubikRegular'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['RubikBold'] text-[16px] leading-[100%] uppercase p-4 rounded-[4px] bg-[#b6091e] text-[#ffffff] !border-0 cursor-pointer w-fit",
      input: {
        base: "font-['RubikRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#000000]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['RubikRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['RubikRegular'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton: "font-['RubikRegular'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#f5f5f5] px-[40px] py-[48px]",
        title:
          "font-['RubikBlack'] text-[24px] leading-[120%] uppercase text-[#b6091e] text-center",
        text: "font-['RubikRegular'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#000000] bg-white font-['RubikRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    global: {
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[190px] h-[48px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[190px] h-[48px] object-contain",
      },
      modalWindow: { container: "", title: "", subtitle: "" },
      bgColor: "#417dbb",
      // Sidebar: solid black background, centered items (asideStyles kept minimal).
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['RubikRegular']",
      primaryButton:
        "rounded-[4px] px-[18px] py-[18px] !text-[#ffffff] font-['RubikBold'] !text-[16px] text-left uppercase leading-[100%] bg-[#b6091e] !border-0",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffffff80]",
      separator: "border-[#ffffff80]",
      item: "font-['RubikBlack'] text-[14px] text-[#ffffff] uppercase text-center leading-[100%] gap-x-[10px] border-b border-[#ffffff80] !pl-0 !py-3 text-opacity-50",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      // CUSTOM OVERRIDE (landing): container copied from reference structure + radius 16 from spec.
      // overflow-hidden clips sections/cards/dividers to the rounded corners.
      container: "!bg-[#ffffff]  rounded-[16px] overflow-hidden !pb-8",
      titles: "text-[#b6091e] font-['RubikBlack'] text-[26px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        // sectionContainer + scrollMenu copied from reference.
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-4 border-[#DBDBDB80]",
        sectionTitle:
          "text-[#b6091e] font-['RubikBlack'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          // overflow hidden + fixed media sizes; no border on cards (web), vertical-only content padding.
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover !rounded-[8px]",
          placeholderMedia: "w-full !aspect-square bg-gray-400 !rounded-[8px]",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#b6091e] font-['RubikBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        // sectionContainer + scrollMenu copied from reference.
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-4 border-[#DBDBDB80]",
        sectionTitle:
          "text-[#b6091e] font-['RubikBlack'] text-[26px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          // overflow hidden + fixed media sizes; no border on cards (web).
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff] rounded-[8px]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover !rounded-[8px]",
          placeholderMedia: "w-full !aspect-video bg-gray-400 !rounded-[8px]",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title: "text-[#b6091e] font-['RubikBold'] text-[16px] uppercase text-left leading-[110%]",
          subtitle:
            "text-[#000000] font-['RubikRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#000000] font-['RubikRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#000000] font-['RubikRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['RubikBlack'] text-[24px] uppercase text-left leading-[110%]",
        text: "font-['RubikRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#b6091e] font-['RubikBlack'] text-[26px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    // Links page — mapped per .agents/skills/onboard-community/references/wm.md#links-page from WM atoms (radioradio layout).
    // White cards / black borders over blue page bg; headers & body on the page use white.
    linktree: {
      bgDesktop: `${S3_PREFIX}web-background-non-member.jpg`,
      bgMobile: `${S3_PREFIX}web-background-non-member.jpg`,
      bgColor: "#417dbb",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#417dbb]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full object-cover border-2 border-[#000000]",
        name: "text-[#ffffff] font-['RubikBlack'] text-[26px] leading-[31.2px] uppercase text-center mt-4 mb-1",
        location: "text-[#ffffff] font-['RubikBold'] leading-[19.2px] text-[16px] text-center mb-2",
        description:
          "text-[#ffffff] font-['RubikRegular'] text-[14px] leading-[120%] text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border-2 border-[#000000] rounded-[8px] text-[#000000] font-['RubikRegular'] text-[14px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ffffff] border-2 border-[#000000] rounded-[8px]",
          title: "text-[#000000] font-['RubikBold'] leading-[19.2px] text-[16px] text-center mb-1",
          text: "text-[#000000] font-['RubikRegular'] text-[14px] leading-[120%] text-center",
          button:
            "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['RubikBlack'] leading-[19.2px] text-[16px] uppercase text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border-2 border-[#000000] rounded-[8px]",
          duration: "text-[#000000] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#b6091e] font-['RubikBold'] leading-[19.2px] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000] rounded-[8px]",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ffffff] border-2 border-[#000000] rounded-[8px]",
          name: "text-[#b6091e] font-['RubikBold'] leading-[19.2px] text-[16px] uppercase text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] text-[#ffffff] font-['RubikRegular'] text-[14px] uppercase leading-[16.8px] text-center",
          duration: "text-[#000000] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          location: "text-[#000000] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t-2 border-[#000000]",
            name: "text-[#000000] font-['RubikRegular'] leading-[16.8px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#000000] font-['RubikBold'] leading-[16.8px] text-[14px] text-left",
            link: "text-[#000000] font-['RubikRegular'] text-[13px] leading-[15.6px] text-left",
            status: "text-[#000000] font-['RubikBold'] leading-[120%] text-[14px] text-left",
            button:
              "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['RubikRegular'] text-[14px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border-2 border-[#000000] rounded-[8px] text-[#000000] font-['RubikRegular'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['RubikBlack'] leading-[19.2px] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border-2 border-[#000000] rounded-[8px]",
          name: "text-[#b6091e] font-['RubikBold'] leading-[19.2px] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[#000000] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#000000] rounded-[8px]",
        },
        seeAllNews:
          "text-[#ffffff] font-['RubikRegular'] text-[14px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border-2 border-[#000000] rounded-[8px] text-[#000000] font-['RubikRegular'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['RubikBlack'] leading-[19.2px] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border-2 border-[#000000] rounded-[8px]",
          coverUrl: "overflow-hidden m-2 border border-[#000000] rounded-[8px]",
          duration: "text-[#000000] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          liveType: "text-[#b6091e] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#b6091e] rounded-full",
          playIconColor: "#000000",
          start: "text-[#000000] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#b6091e] font-['RubikBold'] leading-[19.2px] text-[16px] uppercase text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['RubikRegular'] text-[14px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ffffff] border-2 border-[#000000] rounded-[8px] text-[#000000] font-['RubikRegular'] text-[14px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['RubikBlack'] leading-[19.2px] text-[16px] uppercase text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ffffff] border-2 border-[#000000] rounded-[8px]",
          name: "text-[#000000] font-['RubikBold'] leading-[19.2px] text-[16px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#ffffff] font-['RubikRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] rounded-[16px] overflow-hidden !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b-4 border-[#DBDBDB80]",
        // fixed media size; event media has no border on web.
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#b6091e] font-['RubikBlack'] text-[26px] uppercase text-left leading-[110%]",
        subtitle:
          "text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "rounded-[4px] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['RubikBold'] !text-[16px] text-left uppercase leading-[100%] bg-[#b6091e] border border-[#000000]",
        questions: "text-[14px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-4 border-[#DBDBDB80]",
        header: "text-[#b6091e] font-['RubikBlack'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-4 border-[#DBDBDB80]",
        header: "text-[#b6091e] font-['RubikBlack'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        // CUSTOM OVERRIDE: map overflow-hidden; radius 8 + rowGap 10 from spec.
        map: "w-full h-[206px] overflow-hidden rounded-[8px] gap-y-[10px]",
        mapPinColor: "#b6091e",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#b6091e] font-['RubikBlack'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#b6091e] font-['RubikBlack'] text-[24px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        // Outer container: no border — relies on parent container border.
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          // Reference structure: border-b divider between tickets, vertical-only padding.
          container:
            "flex flex-row justify-between !bg-[#ffffff] border-b-4 border-[#DBDBDB80] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#b6091e] font-['RubikBold'] text-[16px] uppercase text-left leading-[110%] mb-1",
          description:
            "text-[#000000] font-['RubikRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#000000] font-['RubikBold'] text-[16px] uppercase text-left leading-[110%]",
          quantity:
            "text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#000000] font-['RubikBold'] text-[16px] uppercase text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff] border-2 border-[#000000] rounded-[4px] px-[12px] py-[12px] text-[#000000] font-['RubikBold'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default SNEAKFREAXX
